import { Link } from "@tanstack/react-router";
import { Logo } from "./Logo";

interface SiteHeaderProps {
  /** Subtitle to show beneath the logo wordmark. */
  sub?: string;
  /** Currently-active top-level path, for nav highlight. */
  active?: "home" | "games" | "glossary" | "stories" | "quotes" | "about" | "live";
}

/**
 * Site-wide header. One source of truth for top navigation across every page.
 * Keep YouTube as a single, subtle pill — not duplicated next to other CTAs.
 */
export function SiteHeader({ sub = "Quotes", active }: SiteHeaderProps) {
  const link = (a: typeof active) =>
    `text-sm transition ${active === a ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`;

  return (
    <header className="border-b border-border/60">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-5 gap-4">
        <Logo sub={sub} />
        <nav aria-label="Primary" className="flex items-center gap-3 sm:gap-5">
          <Link to="/games" className={link("games")}>Games</Link>
          <Link to="/stories" className={link("stories")}>Stories</Link>
          <Link to="/quotes" className={link("quotes")}>Quotes</Link>
          <Link to="/glossary" className={`hidden sm:inline ${link("glossary")}`}>Glossary</Link>
          <Link to="/about" className={`hidden sm:inline ${link("about")}`}>About</Link>
          <Link to="/live" className="rounded-full border border-gold/40 bg-gold/10 px-3 py-1.5 text-[10px] sm:text-xs uppercase tracking-widest text-gold hover:bg-gold/15 transition">
            Live
          </Link>
        </nav>
      </div>
    </header>
  );
}
